export const menuConfig = {
    profile: {
        label: 'Lý lịch khoa học',
        icon: 'fa-address-card',
        isAdminMenu: false,
        items: [
            { name: 'Thông tin liên hệ', icon: 'fa-solid fa-id-card', path: '/thong-tin-lien-he' },
            { name: 'Lý lịch khoa học', icon: 'fa-solid fa-file-lines', path: '/ly-lich-khoa-hoc' },
            { name: 'Quá trình công tác', icon: 'fa-solid fa-briefcase', path: '/qua-trinh-cong-tac' },
            { name: 'Quá trình đào tạo', icon: 'fa-solid fa-user-graduate', path: '/qua-trinh-dao-tao' },
            { name: 'Lĩnh vực nghiên cứu', icon: 'fa-solid fa-magnifying-glass', path: '/linh-vuc-nghien-cuu-ca-nhan' },
            { name: 'Chuyên ngành giảng dạy', icon: 'fa-solid fa-chalkboard-user', path: '/chuyen-nganh-giang-day-ca-nhan' },
            { name: 'Học vị - Chức danh nghề nghiệp', icon: 'fa-solid fa-book', path: '/hoc-vi-chuc-danh' },
            { name: 'Trình độ ngoại ngữ', icon: 'fa-solid fa-language', path: '/ngoai-ngu-ca-nhan' },
            { name: 'Danh hiệu - Giải thưởng', icon: 'fa-solid fa-award', path: '/danh-hieu-giai-thuong' },
            { name: 'Hướng dẫn Sau đại học', icon: 'fa-solid fa-user-pen', path: '/huong-dan-sau-dai-hoc' },
        ]
    },
    pub: {
        label: 'Công bố khoa học',
        icon: 'fa-file-alt',
        isAdminMenu: false,
        items: [
            { name: 'Bài báo - Tham luận', icon: 'fa-solid fa-file-invoice', path: '/bai-bao-tham-luan' },
            { name: 'Đề tài', icon: 'fa-solid fa-file', path: '/de-tai' },
            { name: 'Sách - Giáo trình', icon: 'fa-solid fa-book', path: '/sach-giao-trinh' },
            { name: 'Nội dung NCKH khác', icon: 'fa-solid fa-folder', path: '/NCKH-khac' },
        ]
    },
    idea: {
        label: 'Sáng kiến',
        icon: 'fa-lightbulb',
        isAdminMenu: false,
        items: [
            { name: 'Danh sách sáng kiến', icon: 'fa-solid fa-lightbulb', path: '/danh-sach-sang-kien' },
        ]
    },
    register: {
        label: 'Đề xuất - Đăng ký',
        icon: 'fa-pen-nib',
        isAdminMenu: false,
        items: [
            { name: 'Đề xuất đề tài', icon: 'fa-solid fa-pen-nib', path: '/de-xuat-de-tai' },
            { name: 'Đăng ký biên soạn', icon: 'fa-solid fa-book', path: '/dang-ky-bien-soan' },
            { name: 'Đăng ký tham dự hội nghị', icon: 'fa-regular fa-building', path: '/dang-ky-tham-du-hoi-nghi' },
            { name: 'Sinh viên NCKH', icon: 'fa-solid fa-user-graduate', path: '/sinh-vien-nckh' },
            { name: 'Hỗ trợ công bố khoa học', icon: 'fa-solid fa-clipboard', path: '/ho-tro-cong-bo-khoa-hoc' },
        ]
    },
    scoring: {
        label: 'Tính điểm khoa học',
        icon: 'fa-calculator',
        isAdminMenu: false,
        items: [
            { name: 'Tính điểm', icon: 'fa-solid fa-calculator', path: '/tinh-diem' },
            { name: 'Kê khai giảm giờ định mức', icon: 'fa-solid fa-file-signature', path: '/ke-khai-giam-gio-dinh-muc' },
            { name: 'Giờ định mức', icon: 'fa-solid fa-clock', path: '/gio-dinh-muc' },
        ]
    },
    userMgmt: {
        label: 'Quản lý người dùng',
        icon: 'fa-users-gear',
        isAdminMenu: true,
        items: [
            { name: 'Người dùng', icon: 'fa-solid fa-user', path: '/nguoi-dung' },
            { name: 'Cơ cấu tổ chức', icon: 'fa-solid fa-sitemap', path: '/co-cau-to-chuc' },
        ]
    },
    sciMgmt: {
        label: 'Quản lý khoa học',
        icon: 'fa-flask-vial',
        isAdminMenu: true,
        items: [
            { name: 'Bài báo - Tham luận', icon: 'fa-solid fa-file-invoice', path: '/quan-ly-bai-bao' },
            { name: 'Đề tài', icon: 'fa-solid fa-file', path: '/quan-ly-de-tai' },
            { name: 'Sách - Giáo trình', icon: 'fa-solid fa-book', path: '/quan-ly-sach-giao-trinh' },
            { name: 'Nội dung NCKH Khác', icon: 'fa-solid fa-folder-open', path: '/quan-ly-noi-dung-NCKH-khac' },
            { name: 'Quản lý tạp chí', icon: 'fa-solid fa-rss', path: '/quan-ly-tap-chi' },
            { name: 'Quản lý điểm', icon: 'fa-solid fa-star', path: '/quan-ly-diem' },
            { name: 'Quản lý kê khai giảm giờ', icon: 'fa-solid fa-clock-rotate-left', path: '/quan-ly-ke-khai-giam-gio' },
            { name: 'Quản lý giờ định mức', icon: 'fa-solid fa-business-time', path: '/quan-ly-gio-dinh-muc' },
        ]
    },
    regMgmt: {
        label: 'Quản lý đề xuất - đăng ký',
        icon: 'fa-book-open-reader',
        isAdminMenu: true,
        items: [
            { name: 'Đề xuất đề tài', icon: 'fa-solid fa-file-pen', path: '/quan-ly-de-xuat-de-tai' },
            { name: 'Đăng ký biên soạn', icon: 'fa-solid fa-book-journal-whills', path: '/quan-ly-dang-ky-bien-soan' },
            { name: 'Đăng ký tham dự hội nghị', icon: 'fa-solid fa-hotel', path: '/quan-ly-dang-ky-tham-du-hoi-nghi' },
            { name: 'Sinh viên NCKH', icon: 'fa-solid fa-graduation-cap', path: '/quan-ly-sinh-vien-nckh' },
            { name: 'Hỗ trợ công bố khoa học', icon: 'fa-solid fa-medal', path: '/quan-ly-ho-tro-cong-bo-khoa-hoc' },
        ]
    },
    qlSangKien: {
        label: 'Quản lý sáng kiến',
        icon: 'fa-vial-circle-check',
        isAdminMenu: true,
        items: [
            { name: 'Danh sách sáng kiến', icon: 'fa-solid fa-lightbulb', path: '/quan-ly-sang-kien' },
        ]
    },
    report: {
        label: 'Thống kê - Báo cáo',
        icon: 'fa-chart-line',
        isAdminMenu: true,
        items: [
            { name: 'Thống kê nguồn nhân lực', icon: 'fa-solid fa-chart-pie', path: '/thong-ke-nhan-luc' },
            { name: 'Thống kê bài báo theo giảng viên', icon: 'fa-solid fa-chart-column', path: '/thong-ke-bai-bao-giang-vien' },
            { name: 'Thống kê bài báo theo loại', icon: 'fa-solid fa-chart-area', path: '/thong-ke-bai-bao-loai' },
            { name: 'Thống kê bài báo theo đơn vị', icon: 'fa-solid fa-sitemap', path: '/thong-ke-bai-bao-don-vi' },
            { name: 'Thống kê đề xuất theo đơn vị', icon: 'fa-solid fa-chart-line', path: '/thong-ke-de-xuat-don-vi' },
            { name: 'Thống kê đề xuất theo cá nhân', icon: 'fa-solid fa-chart-simple', path: '/thong-ke-de-xuat-ca-nhan' },
        ]
    },
    category: {
        label: 'Quản lý danh mục',
        icon: 'fa-gear',
        isAdminMenu: true,
        items: [
            { name: 'Cấp khen thưởng', icon: 'fa-solid fa-medal', path: '/cap-khen-thuong' },
            { name: 'Quốc gia', icon: 'fa-solid fa-flag', path: '/quoc-gia' },
            { name: 'Ngoại ngữ', icon: 'fa-solid fa-language', path: '/ngoai-ngu' },
            { name: 'Trình độ', icon: 'fa-solid fa-layer-group', path: '/trinh-do' },
            { name: 'Lĩnh vực nghiên cứu', icon: 'fa-solid fa-microscope', path: '/linh-vuc-nghien-cuu' },
            { name: 'Loại khen thưởng', icon: 'fa-solid fa-award', path: '/loai-khen-thuong' },
            { name: 'Chức danh', icon: 'fa-solid fa-user-tie', path: '/chuc-danh' },
            { name: 'Loại công trình', icon: 'fa-solid fa-folder-tree', path: '/loai-cong-trinh' },
            { name: 'Cấp đề tài', icon: 'fa-solid fa-tags', path: '/cap-de-tai' },
            { name: 'Nội dung NCKH khác', icon: 'fa-solid fa-flask', path: '/noi-dung-NCKH-khac' },
            { name: 'Loại tạp chí', icon: 'fa-solid fa-newspaper', path: '/loai-tap-chi' },
            { name: 'Giờ chuẩn', icon: 'fa-solid fa-clock', path: '/gio-chuan' },
            { name: 'Giảm trừ NCKH', icon: 'fa-solid fa-minus-circle', path: '/giam-tru-nckh' },
            { name: 'Chuyên ngành giảng dạy', icon: 'fa-solid fa-chalkboard-user', path: '/chuyen-nganh-giang-day' },
        ]
    }
};